export default "__VITE_ASSET__BDRNhWlk__"